import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {ApiClientService} from '../../services/api-client.service';

@Component({
    selector: 'settings-amenities-filter',
    templateUrl: './settings-amenities-filter.component.html',
    styleUrls: ['./settings-amenities-filter.component.scss']
})
export class SettingsAmenityFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('dailyCheckbox')      daily:       ElementRef;
    @ViewChild('timeSlotCheckbox')   timeSlot: ElementRef;
    @ViewChild('hourlyCheckbox')     hourly:     ElementRef;

    @ViewChild('activeCheckbox')     active:     ElementRef;
    @ViewChild('inactiveCheckbox')   inactive:       ElementRef;

    constructor(
        public api: ApiClientService,
        private urlService: UrlService
    ) {}

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(() => {
            const status = this.urlService.queryParams['type'];
            if (status) {
                this.daily.nativeElement.checked = status.indexOf('daily') !== -1;
                this.timeSlot.nativeElement.checked = status.indexOf('range') !== -1;
                this.hourly.nativeElement.checked = status.indexOf('hourly') !== -1;
            } else {
                this.daily.nativeElement.checked = false;
                this.timeSlot.nativeElement.checked = false;
                this.hourly.nativeElement.checked = false;
            }

            const priority = this.urlService.queryParams['enable_status'];
            if (priority) {
                this.active.nativeElement.checked = priority.indexOf('1') !== -1;
                this.inactive.nativeElement.checked = priority.indexOf('0') !== -1;
            } else {
                this.active.nativeElement.checked = false;
                this.inactive.nativeElement.checked = false;
            }

        });
    }

    changeFilter(filterName?: string) {
        const dailyValue = this.daily.nativeElement.checked;
        const timeSlotValue = this.timeSlot.nativeElement.checked;
        const hourlyValue = this.hourly.nativeElement.checked;

        const activeValue = this.active.nativeElement.checked;
        const inactiveValue = this.inactive.nativeElement.checked;

        if (!dailyValue && !timeSlotValue && !hourlyValue) {
            this.urlService.queryParams['type'] = null;
        } else {
            let type = '';
            if (dailyValue) type += 'daily,';
            if (timeSlotValue) type += 'range,';
            if (hourlyValue) type += 'hourly,';
            this.urlService.queryParams['type'] = type.slice(0, -1);
        }

        if ((!activeValue && !inactiveValue) || (activeValue && inactiveValue)) {
            this.urlService.queryParams['enable_status'] = null;
        } else {
            let status = '';
            if (activeValue) status = '1';
            if (inactiveValue) status = '0';
            this.urlService.queryParams['enable_status'] = status;
        }
        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('settings-amenities-filter')) this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/settings-amenities-filter/settings-amenities-filter.component.ts